<template>
    <div>
        <header class="header_style nav-stacked affix-top" data-spy="affix" data-offset-top="1">
            <nav id="navigation_bar" class="navbar navbar-expand-lg">
                <div class="container p-3">
                    <div class="row header-row align-items-center">
                        <div class="col-md-3">
                            <div class="navbar-header">
                                <div class="logo">
                                    <a href="/ofertas"><img src="/assets/images/logo/logo_light2.png"
                                            alt="Logo-Redautos" /></a>
                                </div>
                                <button id="menu_slide" data-target="#navigation" aria-expanded="false"
                                    data-toggle="collapse" class="navbar-toggler" type="button">
                                    <i class="fa fa-bars"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-9">
                            <div class="header_wrap" v-if="userAuth() != null">
                                <div class="user_login m-2">
                                    <ul>
                                        <li class="dropdown">
                                            <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i
                                                    class="fa fa-user-circle" aria-hidden="true"></i>
                                                {{ usuario }}
                                                <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                            <ul class="dropdown-menu">
                                                <li>
                                                    <a href="/logout">Cerrar Sesión</a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                <div class="login_btn m-2">
                                    <a href="/admin/home" class="btn btn-xs uppercase" data-toggle="modal"
                                        data-dismiss="modal">Ingresar</a>
                                </div>
                            </div>
                            <div class="user_login m-2">
                                <ul>
                                    <li class="dropdown">
                                        <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-cog"></i>

                                            <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <a :href="'/ficha_inspeccion/download/' + fichaId" target="_blank">Descargar Ficha</a>

                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
import Permissions from "mixins/Permissions";
import config from "config/config.json";
export default {
    data() {
        return {
            logo:
                "https://brokcars-assets.s3.us-east-2.amazonaws.com" +
                config.logo_url,
            usuario: '',
            fichaId: null,
        };
    },
    created() {
        this.get_usuario();
        this.fichaId = this.getLastSegment();
    },
    methods: {
        userAuth() {
            return Permissions.methods.$getIdUser();
        },
        get_usuario() {
            axios.get('/ajax/get_usuarios').then((response) => {
                var parsingUsuarios = _.orderBy(
                    response.data.usuarios,
                    ['name'],
                    ['asc'],
                )
                let users = parsingUsuarios.filter(usuario => usuario._id == this.userAuth());
                this.usuario = users[0].name;

            })
        },
        getLastSegment() {
            const path = window.location.pathname;
            return path.split('/').pop();
        },
    }
};
</script>

<style lang="scss" scoped></style>
